import './reset.css';

import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';

// import VConsole from 'vconsole';
import App from './App';
import { callintent } from './Layout/download/event';
import { getDevice, isInFacebookBrowser, isPwaSource } from './utils/utils';

// PWA配置
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/service-work.js')
    .then(registration => {
      console.log('Service Worker registered with scope: ' + registration.scope);
    })
    .catch(error => {
      console.log('Service Worker registration failed: ' + error);
    });
}
/** 重写document的append方法，监听所有js和css请求 */
const originalAppend = document.head.appendChild.bind(document.head);
document.head.appendChild = function <T extends Node>(element: T): T {
  if (element instanceof HTMLLinkElement || element instanceof HTMLScriptElement) {
    const cookieRes = document.cookie.split(';').find(row => row.trim().startsWith('ORIGINAL_DOMAIN='));
    const ORIGINAL_DOMAIN = cookieRes?.split('=')[1];

    if (ORIGINAL_DOMAIN && ORIGINAL_DOMAIN !== window.location.origin) {
      // 处理src或href属性
      if (element instanceof HTMLScriptElement && element.src) {
        element.src = element.src.replace(window.location.origin, ORIGINAL_DOMAIN);
      }
      if (element instanceof HTMLLinkElement && element.href) {
        element.href = element.href.replace(window.location.origin, ORIGINAL_DOMAIN);
      }
    }
  }
  return originalAppend(element);
};

// 同样重写insertBefore方法
const originalInsertBefore = document.head.insertBefore.bind(document.head);
document.head.insertBefore = function <T extends Node>(newElement: T, referenceElement: Node | null): T {
  if (newElement instanceof HTMLLinkElement || newElement instanceof HTMLScriptElement) {
    const cookieRes = document.cookie.split(';').find(row => row.trim().startsWith('ORIGINAL_DOMAIN='));
    const ORIGINAL_DOMAIN = cookieRes?.split('=')[1];

    if (ORIGINAL_DOMAIN && ORIGINAL_DOMAIN !== window.location.origin) {
      // 处理src或href属性
      if (newElement instanceof HTMLScriptElement && newElement.src) {
        newElement.src = newElement.src.replace(window.location.origin, ORIGINAL_DOMAIN);
      }
      if (newElement instanceof HTMLLinkElement && newElement.href) {
        newElement.href = newElement.href.replace(window.location.origin, ORIGINAL_DOMAIN);
      }
    }
  }
  return originalInsertBefore(newElement, referenceElement);
};
// import.meta.env.VITE_DEBUG === 'true' && new VConsole();

if (isPwaSource() && getDevice() === 'android' && isInFacebookBrowser()) {
  document.body.addEventListener('click', () => {
    callintent();
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <IntlProvider locale="en-US">
    <App />
  </IntlProvider>
);
